import React, { useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { DeleteButton, Page } from '~/components';
import { useAuth, useDocumentTitle } from '~/hooks';
import { colors, weights } from '~/styles';
import WorkspaceDeleteConfirmation from '../settings/general/WorkspaceDeleteConfirmation';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 64rem;
`;

const Title = styled.h2`
  font-size: 1.625rem;
  font-weight: ${weights.light};
  line-height: 1.2;
`;

const Description = styled.p`
  margin-top: 1rem;
`;

const Actions = styled.p`
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;
`;

const LinkButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
  padding: 0.5em 1.75em;
  color: ${colors.white};
  font-weight: ${weights.bold};
  white-space: nowrap;
  background-color: ${colors.primary};
  border: solid 1px transparent;
  border-radius: 999rem;
  cursor: pointer;

  &:hover {
    color: ${colors.white};
    background-color: ${colors.accent};
  }
`;

export default function WorkspaceBillingLocked() {
  useDocumentTitle('Workspace Locked');

  const auth = useAuth();
  const { url } = useRouteMatch();
  const [showDelete, setShowDelete] = useState(false);

  return (
    <Page>
      <Wrapper>
        <Title>Workspace Locked</Title>
        <Description>There is a problem with the subscription for this workspace.</Description>
        {auth.workspace.manage ? (
          <>
            <Description>
              To continue using this workspace, click the "Review Billing" button below. For other questions or
              assistance, click the "Help & Support" icon at the top of the screen or email us at{' '}
              <a href="mailto:help@ruddr.io">help@ruddr.io</a>.
            </Description>
            <Actions>
              <LinkButton to={`${url}/settings/billing`}>Review Billing</LinkButton>
              <DeleteButton onClick={() => setShowDelete(true)}>Delete Workspace</DeleteButton>
            </Actions>
          </>
        ) : (
          <Description>
            To continue using this workspace, ask a Workspace Admin to log in and check the status of the subscription.
            For other questions or assistance, click the "Help & Support" icon at the top of the screen or email us at{' '}
            <a href="mailto:help@ruddr.io">help@ruddr.io</a>.
          </Description>
        )}
      </Wrapper>
      {showDelete && <WorkspaceDeleteConfirmation onClose={() => setShowDelete(false)} />}
    </Page>
  );
}
